<template>
  <div class="reply-icon pointer d-flex align-items-center justify-content-around">
    <el-tooltip
      :visible-arrow="false"
      effect="dark"
      content="Trả lời"
      placement="bottom-end">
      <el-image
        v-if="message.isShowReplyIcon"
        class="mx-1"
        style="object-fit: contain; height: 18px; width: 18px"
        @click="$emit('showRepliedMessage', message)"
        src="/assets/icon/reply.svg" />
    </el-tooltip>
    <el-tooltip
      :visible-arrow="false"
      effect="dark"
      content="Chia sẻ"
      placement="bottom-end">
      <el-image
        v-if="message.isShowMessageSharePopup"
        class="me-1"
        style="object-fit: contain; max-height: 15px; max-width: 15px"
        @click="$emit('showMessageSharePopup', message)"
        src="/assets/icon/icon_share.svg" />
    </el-tooltip>
    <CustomPopover
      placement="top-start"
      width="180"
      trigger="click"
      v-model="message.visiblePopup">
      <div
        style="margin: -12px"
        class="py-2 font-size-14 pointer">
        <div
          @click="$emit('copy', message)"
          v-if="message.isShowListIcon && message.msgType === 'webchat'"
          class="item-popover py-2 ps-2">
          <span><i class="el-icon-copy-document me-2"></i></span>
          Copy tin nhắn
        </div>
        <div
          @click="$emit('dowloadImage', message)"
          v-if="message.isShowListIcon && message.msgType === 'chat.photo'"
          class="item-popover py-2 ps-2">
          <span><i class="el-icon-download me-2"></i></span>
          Lưu ảnh về máy
        </div>
        <div
          @click="$emit('undoMessage', message)"
          v-if="message.isShowUndoIcon"
          v-bind:style="message.id.uidFrom !== '0' ? 'display:none' : ''"
          class="item-popover py-2 ps-2">
          <span><i class="el-icon-refresh-left me-2" /></span>
          Thu hồi
        </div>
        <!--                                  <div @click="deleteMessage(message)" class="item-popover py-2 ps-2"><span><i-->
        <!--                                    class="el-icon-delete me-2"> </i>  </span>Xoá chỉ ở phía tôi-->
        <!--                                  </div>-->
        <div
          @click="$emit('pinMessage', message)"
          v-if="message.isShowListIcon && message.isCanPin"
          class="item-popover py-2 ps-2">
          <span>
            <img
              src="/assets/icon/pin.svg"
              style="height: 15px; width: 15px"
              class="me-2" />
          </span>
          Ghim tin nhắn
        </div>
      </div>

      <el-tooltip
        :disabled="true"
        slot="reference"
        effect="dark"
        content="Thêm"
        placement="bottom">
        <el-image
          v-if="message.isShowThreeDot"
          class="me-1"
          style="object-fit: contain; max-height: 16px; max-width: 20px"
          src="/assets/images/three_dots.svg" />
      </el-tooltip>
    </CustomPopover>
  </div>
</template>

<script>
import CustomPopover from "./common/popover/CustomPopover";

export default {
  props: ["message"],
  components: {
    CustomPopover,
  },
  computed: {

  },
};
</script>

<style>
</style>
